export const SECRETARIA = 'SECRETARIA';
export const BOLETO = 'BOLETO';
export const PIX = 'PIX';

export const listSelect = [
    { code: SECRETARIA, value: SECRETARIA }, 
    { code: BOLETO, value: BOLETO }, 
    { code: PIX, value: PIX }, 
]